import React from 'react';

/* Error boundary dedicated to the Cover Letter flow — a crash inside the
   modal must NEVER unmount the whole app (white screen). Shows a retry
   fallback that remounts the modal from scratch. */
export class CoverLetterErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, attempt: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[CoverLetter] crashed while rendering:', error?.message || error, {
      roleTitle: this.props.roleTitle,
      componentStack: info?.componentStack,
    });
  }

  retry = () => this.setState((s) => ({ hasError: false, attempt: s.attempt + 1 }));

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4 animate-fade-in"
          onClick={this.props.onClose}
          data-testid="cover-letter-error-boundary"
        >
          <div
            className="bg-white rounded-card shadow-card-deep max-w-[440px] w-full p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="text-[16px] font-semibold text-sd-black mb-1.5">
              We couldn't generate your cover letter.
            </div>
            <div className="text-[13.5px] text-sd-mid-gray mb-4">
              Something went wrong on our side — the rest of your work is safe. Retry, or close and reopen the draft.
            </div>
            <div className="flex gap-2 justify-end">
              <button
                type="button"
                className="sd-btn-secondary !py-2 !px-4 !text-[13px]"
                onClick={this.props.onClose}
                data-testid="cover-letter-crash-close"
              >
                Close
              </button>
              <button
                type="button"
                className="sd-btn-primary !py-2 !px-4 !text-[13px]"
                onClick={this.retry}
                data-testid="cover-letter-crash-retry"
              >
                Retry
              </button>
            </div>
          </div>
        </div>
      );
    }
    return <React.Fragment key={this.state.attempt}>{this.props.children}</React.Fragment>;
  }
}
